import React, { useState, useEffect } from 'react'
import Typography from '@material-ui/core/Typography'
import Paper from '@material-ui/core/Paper'
import Container from '@material-ui/core/Container'
import Pagination from '@material-ui/lab/Pagination'
import { useParams } from 'react-router-dom'
import moment from 'moment'

import Error from '../../../components/Error'
import Spinner from '../../../components/Spinner'
import { getAlerts, AlertsListResponse } from './utils'
import { useStyles } from './styles'
import AlertsToolbar from './Toolbar'
import {
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody
} from '@material-ui/core'
import Moment from 'react-moment'

interface State {
  loading: boolean
  error: string
  results: AlertsListResponse['data']['results']
  pageCount: number
  page: number
  dateFrom: string
  dateTo: string
}

interface RouteParams {
  id: string
}

const DeviceAlerts: React.FunctionComponent = () => {
  const { id } = useParams<RouteParams>()

  const [state, setState] = useState<State>({
    loading: false,
    error: '',
    results: [],
    pageCount: 1,
    page: 1,
    dateFrom: moment()
      .startOf('day')
      .subtract(7, 'day')
      .toISOString(),
    dateTo: moment().toISOString()
  })
  const { results, loading, error, dateFrom, dateTo, page, pageCount } = state
  const classes = useStyles()

  const fetchAlerts = async (
    id: string,
    from: string,
    to: string,
    page: number
  ) => {
    setState(prev => ({ ...prev, loading: true }))

    try {
      const response = await getAlerts({ id, from, to, page })
      const pageSize = response.meta.pageSize as number

      setState(prev => ({
        ...prev,
        loading: false,
        results: response.results,
        pageCount: Math.ceil((response.meta.count as number) / pageSize)
      }))
    } catch (err) {
      setState(prev => ({
        ...prev,
        loading: false,
        error: (err as Error).message
      }))
    }
  }

  useEffect(() => {
    fetchAlerts(id, dateFrom, dateTo, page)
  }, [dateFrom, dateTo, page])

  const changeDate = (dateFrom: string, dateTo: string) => {
    setState(prev => ({
      ...prev,
      dateFrom,
      dateTo,
      page: 1
    }))
  }

  if (loading && results.length === 0) {
    return <Spinner legend="Loading list..." />
  }

  if (!loading && error) {
    return <Error legend={error} />
  }

  return (
    <Container>
      <Paper square>
        <AlertsToolbar onChangeDate={changeDate} from={dateFrom} to={dateTo} />
      </Paper>
      {!results.length && (
        <Typography variant="subtitle1" className={classes.textCenter}>
          No alerts found
        </Typography>
      )}
      <div className={classes.pagination}>
        <Pagination
          count={pageCount}
          page={page}
          color="primary"
          onChange={(e: unknown, page: number) => {
            setState(prev => ({
              ...prev,
              page
            }))
          }}
        />
      </div>
      {loading && <Spinner inline legend="Loading list..." />}
      {!loading && (
        <div className={classes.logsContainer}>
          <TableContainer component={Paper}>
            <Table size="small" aria-label="a dense table">
              <TableHead>
                <TableRow>
                  <TableCell>Date</TableCell>
                  <TableCell align="left">Type</TableCell>
                  <TableCell align="left">Transport</TableCell>
                  <TableCell align="left">Status</TableCell>
                  <TableCell align="left">Message</TableCell>
                  <TableCell align="left">Sent at</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {results.map((entry, index) => (
                  <TableRow key={index}>
                    <TableCell component="th" scope="row">
                      <Moment format="YYYY-MM-DD HH:mm">
                        {entry.createdAt as string}
                      </Moment>
                    </TableCell>
                    <TableCell align="left">{entry.type as string}</TableCell>
                    <TableCell align="left">
                      {entry.transport as string}
                    </TableCell>
                    <TableCell align="left">{entry.status as string}</TableCell>
                    <TableCell align="left">
                      {entry.message as string}
                    </TableCell>
                    <TableCell align="left">
                      {entry.sentAt && (
                        <Moment format="YYYY-MM-DD HH:mm">
                          {entry.sentAt as string}
                        </Moment>
                      )}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </div>
      )}
      {!loading && (
        <div className={classes.pagination}>
          <Pagination
            count={pageCount}
            page={page}
            color="primary"
            onChange={(e: unknown, page: number) => {
              setState(prev => ({
                ...prev,
                page
              }))
            }}
          />
        </div>
      )}
    </Container>
  )
}

export default DeviceAlerts
